module.exports = __webpack_public_path__ + "static/media/team-renee.50d0b8f2.jpg";